export default __webpack_public_path__ + "static/media/treasure-chest.f9c6bf6c.svg";